'use client';

import type { TDynamicData } from '@eliadmin/core/src/api/dynamics/dynamics-api';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { PackageCard } from './package-card';
import { Carousel } from '../ui/carousel';
import { useCarouselContext } from '@eliadmin/core/src/components/ui/carousel-context';
import { CarouselProgress } from '../ui/carousel-progress';

export function PackageDisplay({ packages }: { packages: TDynamicData[] }) {
  const options = {
    align: 'start' as const,
  };

  const carouselContext = useCarouselContext();

  if (!carouselContext) {
    throw new Error('Hero must be used within a CarouselProvider');
  }

  const { selectedIndex } = carouselContext;

  return (
    <>
      <div className={cn('custom-container', 'hidden grid-cols-3 gap-6 lg:grid')}>
        {packages.map(item => {
          return <PackageCard key={item.id} item={item} />;
        })}
      </div>
      <div className="flex w-full flex-col items-start justify-start lg:hidden">
        <Carousel
          options={options}
          className={{
            wrapper: 'w-full',
            main: 'w-full',
            container: 'w-full gap-2 sm:gap-3 md:gap-4',
            slide: 'w-full max-w-[340px] sm:max-w-[360px] md:max-w-[400px]',
          }}
          slides={packages.map(item => (
            <PackageCard item={item} key={item.name} />
          ))}
        />
      </div>
      <div className="flex w-full lg:hidden">
        <CarouselProgress selectedIndex={selectedIndex} totalSlides={packages.length} />
      </div>
    </>
  );
}
